import { Carrier, ImportResult, Template, TiendaNubeToken, IDevices, IWarehouses, IOrders, IZones } from './interfaces';

export type GetTemplatesResponse = Template[];

export type SaveTemplateResponse = Template | false;

export type DeleteTemplateResponse = boolean;

export type GetTiendaNubeTokenResponse = TiendaNubeToken | false;

export type GetTiendaNubeCustomCarriersResponse = Carrier[] | false;

export type ImportTiendaNubeResponse = ImportResult | false;

export type GetDispositivosResponse = IDevices[];

export type GetWarehousesResponse = IWarehouses[];

export type GetOrdersResponse = IOrders[];

export type GetZonesResponse = IZones[];
